import React from 'react';

const LoginBanner = () => (
  <div className="applogin-banner">
    <div className="applogin-background" />
    <div className="applogin-container">
      <h1>Connecting to {`Safety Status Check`}</h1>
      <p>Sign-in with your Les Schwab account to access LS</p>
    </div>
  </div>
);
export default LoginBanner;

LoginBanner.propTypes = {};
